import { RootState } from "store";

export const getUser = (state: RootState) => state.user;

export const selectUserProfile = (state: RootState) => state.profile;
